module.exports = __webpack_public_path__ + "img/gza_thumb.edfe69e1.gif";